<template>
    <div>
        <div class="footer" v-if="$estimate()">
            <img :src="this.$URL+'image/logo.png'">
            <div class="footer_left">热线电话：023-60361010</div>
            <div>地址：重庆市经开区迎龙镇美家路1号3号楼(工业厂房)1层</div>
        </div>
        <div class="footer" v-else>
            <div class="footer_item isdisplay">
                <div>
                    <img :src="this.$URL+'image/logoIndex.png'" alt="">
                    <div class="footer_left">热线电话：023-60361010</div>
                    <div class="footer_address">地址:重庆市经开区迎龙镇美家路1号3号楼(工业厂房)1层</div>
                </div>
                <div class="footer_dl isdisplay">
                    <dl>
                        <dt class="footer_dt">公司介绍</dt>
                        <dd class="footer_dd">
                            <router-link to="/intro">公司简介</router-link>
                        </dd>
                        <dd class="footer_dd">
                            <router-link to="/intro">公司荣誉</router-link>
                        </dd>
                        <dd class="footer_dd">
                            <router-link to="/intro">客户与伙伴</router-link>
                        </dd>
                    </dl>
                    <dl>
                        <dt class="footer_dt">产品应用</dt>
                        <dd class="footer_dd">
                            <router-link to="/motorcycle">合作车型</router-link>
                        </dd>
                        <dd class="footer_dd">
                            <router-link to="/microgrid">分布式微电网</router-link>
                        </dd>
                    </dl>
                    <dl>
                        <dt class="footer_dt">新闻中心</dt>
                        <dd class="footer_dd">
                            <router-link to="/journalism">新闻资讯</router-link>
                        </dd>
                    </dl>
                    <dl>
                        <dt class="footer_dt">联系我们</dt>
                        <dd class="footer_dd">
                            <router-link to="/business">商务合作</router-link>
                        </dd>
                        <dd class="footer_dd">
                            <router-link to="/engage">人才招聘</router-link>
                        </dd>
                    </dl>
                </div>
                <div style="height: 12em;">
                    <img :src="this.$URL+'image/code.png'" style="height: 100%;">
                </div>
            </div>
            <div style="text-align: center;font-size: 1.2em;">
                Copyright © 2016-2023 重庆峘能电动车科技有限公司版权所有
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'footerView',
    data() {
        return {}
    },
    methods: {}
}
</script>

<style scoped>
@media screen and (max-width: 768px) {
    .footer {
        padding: 20px 0 40px 20px;
        color: #333333;
        font-size: 13px;
    }

    .footer_left {
        margin: 6px 0;
    }
}

@media screen and (min-width: 1200px) {
    .footer_dd>a {
        color: #FFFFFF;
    }

    .footer_dt {
        font-size: 1.6em;
        font-weight: bold;
        margin-bottom: 15px;
    }

    .footer_dl {
        flex: 1;
        padding-top: 1.5%;
        justify-content: space-between;
        justify-content: space-evenly;
    }

    .footer_address {
        font-size: 1.2em;
    }

    .footer_dd {
        font-size: 1.2em;
        margin-bottom: 5px;
    }

    .footer_left {
        margin-top: 0.5em;
        font-size: 2em;
        font-weight: bold;
    }

    .footer_item {
        justify-content: space-between;
    }

    .isdisplay {
        display: flex;
    }

    .footer {
        color: #FFFFFF;
        padding: 1% 8%;
        background-size: cover;
        background: url('https://image.altener.cn/upload/official/image/fb.png') no-repeat center center;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue